import React from 'react'
import ReactDOM from 'react-dom/client'
import '@mercedes-benz/typeface-mb-corpo-s'
import '@mercedes-benz/typeface-mb-corpo-a'
import './index.css'
import App, { isLocal } from './App'
import reportWebVitals from './reportWebVitals'
import { Provider } from 'react-redux'
import { store } from './source/Store'
import { AuthenticationResult, EventMessage, EventType, PublicClientApplication } from '@azure/msal-browser'
import { msalConfig } from './config/authConfig'
import { MsalProvider } from '@azure/msal-react'
import { MsalReactTester } from 'msal-react-tester'
import './config/i18n'

async function initApp() {
    let msalInstance = await PublicClientApplication.createPublicClientApplication(msalConfig);

    if (!msalInstance.getActiveAccount() && msalInstance.getAllAccounts().length > 0) {
        msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0])
    }

    msalInstance.addEventCallback((event: EventMessage) => {
        if (event.eventType === EventType.LOGIN_SUCCESS && (event.payload as AuthenticationResult).account) {
            msalInstance.setActiveAccount((event.payload as AuthenticationResult).account)
        }
    })

    if (isLocal) {
        const msalTester = new MsalReactTester();
        await msalTester.isLogged();
        msalInstance = msalTester.client;
    }

    const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
    root.render(
        <MsalProvider instance={msalInstance}>
            <Provider store={store}>
                <App />
            </Provider>
        </MsalProvider>
    )
    reportWebVitals()
}

initApp().catch((error) => {
    console.error('Failed to initialize app:', error);
});